import classNames from 'classnames/bind';
import { motion, Variants } from 'framer-motion';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import styles from './CorporateCulture.module.css';

const cx = classNames.bind(styles);

const CardVariants: Variants = {
  offscreen: {
    opacity: 0,
  },
  onscreen: {
    opacity: 1,
    transition: {
      type: 'spring',
      bounce: 0.1,
      duration: 1,
    },
  },
};

const CULTURE_BLOCKS = ['autonomy', 'growth', 'life'] as const;

function CorporateCulture() {
  const { t } = useTranslation('career');

  const subtitle = t('corporate-culture-subtitle', null, { default: '' });
  const note = t('corporate-culture-note', null, { default: '' });

  return (
    <>
      <motion.section
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true }}
        className={cx('main-wrapper')}
      >
        <motion.div variants={CardVariants}>
          <h2 className={cx('title')}>{t('corporate-culture')}</h2>
          {subtitle && <p className={cx('subtitle')}>{subtitle}</p>}
          <div className={cx('image-01')} />
        </motion.div>
      </motion.section>
      <motion.section
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true }}
        className={cx('main-wrapper')}
      >
        <motion.div variants={CardVariants}>
          {CULTURE_BLOCKS.map((block, index) => (
            <div key={block} className={cx('corporate-culture-container')}>
              <div>
                <h2>{String(index + 1).padStart(2, '0')}</h2>
                <h2>
                  <Trans
                    i18nKey={t(`${block}-culture-header`)}
                    components={{
                      br: <br className="disable-mobile-break" />,
                    }}
                  />
                </h2>
              </div>
              <div className={cx('corporate-culture-details')}>
                <h3>
                  <Trans
                    i18nKey={t(`${block}-culture-description`)}
                    components={{
                      br: <br />,
                    }}
                  />
                </h3>
                <div className={cx('corporate-culture-details__list')}>
                  {t<string[][]>(`${block}-culture-benefits`, null, {
                    returnObjects: true,
                  }).map((benefits) => (
                    <ul key={benefits[0]}>
                      {benefits.map((benefit) => (
                        <li key={benefit}>{benefit}</li>
                      ))}
                    </ul>
                  ))}
                </div>
              </div>
            </div>
          ))}
          {note && (
            <p className={cx('note')}>
              <Trans i18nKey={note} components={{ br: <br /> }} />
            </p>
          )}
        </motion.div>
      </motion.section>
    </>
  );
}

export default CorporateCulture;
